













































import RefsCompany from "@/components/utility/RefsCompany.vue";
import { CompanyServiceEnum } from "@/lib/enum/company-service.enum";
import { requiredRule } from "@/lib/rules/requiredRule";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { handleError } from "@/lib/utility/handleError";
import { ICompany } from "@/models/company.entity";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { CompanySearchModule } from "@/store/modules/search.store";
import { debounce } from "debounce";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: { RefsCompany },
  filters: {}
})
export default class CompanySelection extends Vue {
  loadingLocal = false;
  search = "";

  @Prop({ default: null })
  value!: ICompany | null;

  @Prop()
  filter?: CompanyServiceEnum | null;

  @Prop({ default: true })
  cache!: boolean;

  get selectedCompany(): ICompany | null {
    return this.value;
  }

  set selectedCompany(value: ICompany | null) {
    this.$emit("input", value);
  }

  get partner() {
    return PartnerModule.partner;
  }

  get partnerId() {
    return this.partner.id;
  }

  get items() {
    return CompanySearchModule.filtered || [];
  }

  get label() {
    if (this.filter) {
      return this.$t("components.partner.CompanySelection.labelFilter", {
        service: this.$t(`enums.CompanyServiceEnum.${this.filter}`)
      });
    }

    return this.$t("components.partner.CompanySelection.label");
  }

  get rules() {
    return [requiredRule()];
  }

  mounted() {
    this.search = "";
    if (this.filter) {
      CompanySearchModule.setFilters([
        new PageFilterElement({ key: "services", operation: PageFilterOperationEnum.EQUAL, value: this.filter })
      ]);
    } else {
      CompanySearchModule.setFilters([]);
    }
  }

  beforeUnmount() {
    CompanySearchModule.setSearch("");
    CompanySearchModule.setFilters([]);
  }

  @Watch("search")
  async onSearchChange(search: string) {
    this.debounceQuerySelections(search);
  }

  // We have to debounce the input of the user to not fire backend calls after each keystroke
  debounceQuerySelections = debounce(this.querySelections, 500);

  /**
   *  Searches the API directly not via the store
   * @param search the search parameter
   */
  async querySelections(search: string) {
    this.loadingLocal = true;

    try {
      if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.COMPANY, this.partnerId)) {
        CompanySearchModule.setSearch(search);
        await CompanySearchModule.fetchPage({ partnerId: this.partnerId });
      }
    } catch (error) {
      handleError(error);
    } finally {
      this.loadingLocal = false;
    }
  }
}
